<template>
  <div class="createBankAccount">
    <div class="topBakBox">
      <TopBack :title="topTitle"/>
    </div>
    <div class="formBox">
      <div class="formItem">
        <div class="label">{{ $t('lang.account.accountName') }}</div>
        <input v-model="accountInfo.AccountName" type="text" :placeholder="$t('lang.account.accountName')">
      </div>
      <div class="formItem">
        <div class="label">{{ $t('lang.account.accountNo') }}</div>
        <input v-model="accountInfo.AccountNumber" type="text" :placeholder="$t('lang.account.accountNo')">
      </div>
      <div class="formItem">
        <div class="label">Bank Code （IFSC Code)</div>
        <input v-model="accountInfo.BankCode" type="text" :placeholder="$t('lang.account.IFSC')">
      </div>
      <div @click="outLink" class="itemTip">{{ $t('lang.account.outLink') }}</div>
      <div class="claim" @click="setAccount">{{ $t('lang.account.submit') }}</div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import {Toast} from 'mint-ui'
import request from '../../service'
import {InternationBankList, InternationIFSCReg, InternationAccountNumberReg, InternationIDCardReg} from '@/constant'

export default {
  name: 'createBankAccount',
  components: {
    TopBack
  },
  data () {
    return {
      topTitle: this.$t('lang.menu.' + this.$route.name),
      bankListSlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center'
        }
      ],
      IFSCReg: RegExp(/^[A-Za-z]{4}[0]\w{6}$/),
      AccountNameReg: RegExp(/^[a-zA-Z\s]+$/),
      AccountNumberReg: RegExp(/^\d{8,18}$/),
      AadhaarReg: RegExp(/^\d{12}$/),
      // accountDict: {
      //   AccountName: this.$t('lang.account.accountName'),
      //   AccountNumber: this.$t('lang.account.accountNo'),
      //   BankCode: this.$t('lang.account.IFSC')
      // },
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      accountInfo: {
        Id: null,
        AccountName: null,
        AccountNumber: null,
        BankCode: null,
        BankCardVerifyStatus: null
      },
      personalInfo: {
        fullName: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.FullName : null,
        cardNum: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.AadhaarCardNumber : null,
        Birthday: '',
        mobile: ''
      },
      InternationBankList,
      InternationIFSCReg,
      InternationAccountNumberReg,
      InternationIDCardReg
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.accountInfo) {
      this.accountInfo = this.$route.query.accountInfo
    }
    this.title = this.$t('lang.account.withdrawSetup.textYourBank')
    // 2022-02-17 CHP 根据国家版本设置相关信息
    this.bankListSlots[0].values = this.InternationBankList.getBankList(this.$store.state.internation)
    this.IFSCReg = this.InternationIFSCReg.getReg(this.$store.state.internation)
    this.AccountNumberReg = this.InternationAccountNumberReg.getReg(this.$store.state.internation)
  },
  methods: {
    setAccount () {
      if (this.accountInfo.AccountName && this.accountInfo.AccountName.trim() && this.accountInfo.AccountNumber && this.accountInfo.BankCode) {
        if (!this.AccountNameReg.test(this.accountInfo.AccountName.trim())) {
          Toast(this.$t('lang.account.withdrawSetup.promptInvalidAccountName'))
          return
        }
        if (!this.AccountNumberReg.test(this.accountInfo.AccountNumber)) {
          Toast(this.$t('lang.account.withdrawSetup.promptInvalidAccount'))
          return
        }
        if (!this.IFSCReg.test(this.accountInfo.BankCode)) {
          Toast(this.$t('lang.account.withdrawSetup.promptInvalidCard'))
          return
        }
        const url = '/innovation/account/set/userbankaccount'
        const data = {
          UserId: this.userInfo.UserId,
          AccountName: this.accountInfo.AccountName.trim(),
          AccountNumber: this.accountInfo.AccountNumber,
          BankCode: this.accountInfo.BankCode,
          Id: this.accountInfo.Id
        }
        request('post', url, data).then(res => {
          Toast(res.Message)
          if (res.Code > 0) {
            this.accountInfo = {
              Id: null,
              AccountName: null,
              AccountNumber: null,
              BankCode: null,
              BankCardVerifyStatus: null
            }
            this.$router.back()
          }
        }).catch(err => {
          console.log(err)
          Toast(this.$t('lang.account.withdrawSetup.errorUpload'))
        })
      } else if (!this.accountInfo.accountName || !this.accountInfo.accountName.trim()) {
        Toast(this.$t('lang.account.withdrawSetup.promptFillAccountName'))
      } else if (!this.accountInfo.accountNo) {
        Toast(this.$t('lang.account.withdrawSetup.promptFillAccountNumber'))
      } else if (!this.accountInfo.IFSC) {
        Toast(this.$t('lang.account.withdrawSetup.promptFillIFSC'))
      }
    },
    outLink () {
      if (window.Android) {
        window.Location.href = 'https://bankifsccode.com/'
      } else {
        window.open('https://bankifsccode.com/', '_blank')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.topBakBox {
  padding-top: 4vw;
}

.formBox {
  height: 140vw;
  width: 100%;
  padding: 2vw 5vw;
  //border: 1px solid red;
  display: flex;
  flex-direction: column;
  gap: 4vw;
  margin-top: 2vw;

  .itemTip {
    display: flex;
    justify-content: flex-end;
    padding-right: 2vw;
    font-size: 3.88vw;
  }

  .claim {
    background-color: #F6D9AA;
    color: #000D2E;
    font-size: 5vw;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.388vw;
    height: 12.22vw;
  }

  .formItem {
    display: flex;
    flex-direction: column;

    .label {
      color: #F6D9AA;
      font-size: 4.72vw;
      padding-bottom: 2vw;
    }

    input {
      width: 87.77vw;
      height: 10.83vw;
      border: 1px solid rgb(133, 119, 95);
      border-radius: 1.111vw;
      text-align: right;
      padding-right: 2vw;
      color: #F6D9AA;
      font-size: 4.72vw;
    }

    input::placeholder {
      font-size: 4.44vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WithdrawalSuccessful/createBankAccount.vue